import React from 'react';
import { type StatItem } from '../lib/variants';

interface StatsProps {
  stats: StatItem[];
}

const Stats: React.FC<StatsProps> = ({ stats }) => {
  return (
    <section className="py-12 bg-slate-950 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-slate-800">
          {stats.map((stat, index) => (
            <div key={index} className="text-center px-4 pt-8 md:pt-0">
              <div className="text-5xl lg:text-6xl font-extrabold text-cyan-400 mb-2">{stat.value}</div>
              <div className="text-lg font-bold text-white mb-2">{stat.label}</div>
              <div className="text-sm text-slate-400 leading-relaxed">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
